import { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../../../Contexts/AppContext";
import { Device } from "../../../models/Device";
import DeviceApi from "../../../api/device";
import DeviceHistoryTable from "./components/DeviceHistoryTable";

export default function DeviceHistoryScreen() {
	const { id } = useParams();
	const [device, setDevice] = useState<Device | null>(null);

	const { userContext, setTitle } = useContext(AppContext);

	const fetchDevice = useCallback(async () => {
		if (!userContext?.permissionaryId) return;
		try {
			const response = await DeviceApi.getOneDevice({
				token: localStorage.getItem("accessToken") || "",
				query: {
					_id: id,
					permissionaryId: userContext.permissionaryId,
				},
				includeExceptions: false,
			});

			setDevice(response);
		} catch (error) {
			console.error(error);
		}
	}, [id, userContext]);

	useEffect(() => {
		setTitle("Historial");
	}, [setTitle]);

	useEffect(() => {
		fetchDevice();
	}, [fetchDevice]);

	return <div>{device && <DeviceHistoryTable device={device} />}</div>;
}
